const Bill = ({
  className = "",
  color,
}: {
  className?: string;
  color: string;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    aria-labelledby="title"
    aria-describedby="desc"
    role="img"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path data-name="layer2" fill={color} d="M14 14h-4v32h46v-4H14V14z"></path>
    <path data-name="layer2" fill={color} d="M6 22H2v32h46v-4H6V22z"></path>
    <path
      data-name="layer1"
      d="M18 10v28h44V10zm10 10h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4zm12 10a6 6 0 1 1 6-6 6 6 0 0 1-6 6zm14 2h-2a2 2 0 0 1 0-4h2a2 2 0 0 1 0 4z"
      fill={color}
    ></path>
  </svg>
);

export default Bill;
